import { makeStyles } from "@material-ui/core/styles";
import BannerImage from "../../../assets/images/img-otros-plan.png";

const styles = makeStyles(theme => ({
  titleSectionContainer: {
    padding: "60px 16% 45px 16%",
    [theme.breakpoints.down("md")]: {
      padding: "40px"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0"
    }
  },
  titleContainer: {
    display: "flex",
    alignItems: "center"
  },
  titleSection: {
    fontSize: "24px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    fontFamily: "Trebuchet",
    lineHeight: "1.1",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: "440px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "38px"
    }
  },

  lineTitle: {
    borderLeft: "10px solid #0073cf",
    height: "50px",
    marginRight: "15px"
  },
  buttonContainer: {
    width: "200px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #00b9e4",
    borderRadius: "5px",
    textDecoration: "none",
    color: "#0073cf",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: "15px"
    }
  },
  containerButtons: {
    display: "flex",
    marginLeft: "100px",
    justifyContent: "space-between",
    flex: "1",
    maxWidth: "650px"
  },
  tabStyle: {
    color: "rgba(0, 0, 0, 0.87)",
    display: "grid",
    maxWidth: "200px",
    textAlign: "left",
    textTransform: "none",
    justifyContent: "left",
    background: "#fafafa",
    marginBottom: "8px",
    borderRadius: "8px",
    lineHeight: "20px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "115px",
      textAlign: "center",
      lineHeight: "16px",
      marginRight: "8px"
    },
    "&.Mui-selected": {
      background: theme.palette.primary.main,
      color: "rgba(255,255,255,0.87)",
      boxShadow:
        "0 3px 5px -1px rgb(0 0 0 / 20%), 0 1px 18px 0 rgb(0 0 0 / 12%), 0 6px 10px 0 rgb(0 0 0 / 14%)"
      // transition: "left 0.2s ease-in-out, background-color 0.2s ease-out 0.2s"
    }
  },
  root: {
    flexGrow: 1,
    display: "flex",
    marginTop: "40px",
    [theme.breakpoints.down("xs")]: {
      display: "block"
    }
  },
  tabs: {
    // borderRight: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down("xs")]: {
      marginBottom: "20px"
    },
    "& .MuiTabs-scroller .MuiTabs-flexContainer": {
      paddingLeft: "5px",
      paddingRight: "5px"
    }
  },
  indicator: {
    backgroundColor: "transparent"
  },
  videoContainer: {
    width: "100% !important",
    [theme.breakpoints.down("xs")]: {
      // height: "auto !important"
    }
  },
  tabContainer: {
    display: "flex",
    marginLeft: 50,
    [theme.breakpoints.down("lg")]: {
      marginLeft: 22
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      flexDirection: "column"
    }
  },

  tabContainerEmpresarial: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 50,
    [theme.breakpoints.down("lg")]: {
      marginLeft: 22
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      flexDirection: "column"
    }
  },

  descriptionContainer: {
    paddingLeft: 40,
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 0
    }
  },

  descriptionContainerEmpresas: {
    paddingLeft: 0
  },

  tabPanelStyle: {
    maxWidth: "720px",

    [theme.breakpoints.down("lg")]: {
      maxWidth: "650px",
      marginLeft: "0px"
    }
  }
}));

export default styles;
